/**
 * UTF-8 byte length of a string, computed without TextEncoder so it works in
 * every runtime (browser, React Native/Hermes, and the jsdom test env, which
 * does not expose TextEncoder). Matches Node's Buffer.byteLength(s, 'utf-8'),
 * the measure the server uses for storage key/value and leaderboard metadata
 * size limits.
 */
export function utf8ByteLength(s: string): number {
  let bytes = 0
  for (let i = 0; i < s.length; i++) {
    const code = s.charCodeAt(i)
    if (code < 0x80) {
      bytes += 1
    } else if (code < 0x800) {
      bytes += 2
    } else if (code >= 0xd800 && code <= 0xdbff) {
      // High surrogate: a surrogate pair encodes to 4 UTF-8 bytes. Skip the
      // following low surrogate so it isn't counted again.
      bytes += 4
      i++
    } else {
      bytes += 3
    }
  }
  return bytes
}
